<template>
  <div class="account-page">
    <div class="add-btn clearfix">
      <el-button type="primary" class="fr" @click="add">新增</el-button>
    </div>
    <el-form class="search-head" :inline="true" label-position="left">
      <el-form-item label="账号">
        <el-input v-model="form.username" />
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="form.name" />
      </el-form-item>
      <el-form-item label="项目">
        <el-select
          v-model="form.projectId"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item class="search-group">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="reload">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="tabel-box">
      <el-table
        v-loading="listLoading"
        stripe
        style="width:100%"
        border
        :data="tabelData"
      >
        <el-table-column prop="username" label="账号" />
        <el-table-column prop="name" label="姓名" />
        <el-table-column
          prop="projectName"
          label="项目"
        />
        <el-table-column
          prop="lastLoginIp"
          label="上次登录IP"
        />
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span>{{ scope.row.enable ? '开启' : '停用' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="watch(scope.row.id)"
            >查看</el-button>
            <el-button
              type="text"
              size="small"
              @click="handleedit(scope.row.id)"
            >编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.pageIndex"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import { accountpage, projectquery } from '@/api/user'
import Pagination from '@/components/Pagination'
export default {
  components: { Pagination },
  inject: ['reload'],
  data() {
    return {
      listLoading: false,
      listQuery: {
        pageIndex: 1,
        pageSize: 20
      },
      firstSearch: {},
      total: 0, // 总个数
      options: [],
      tabelData: [],
      form: {
        username: null,
        name: null,
        projectId: null
      }
    }
  },
  created() {
    this.firstSearch = {
      username: null,
      name: null,
      projectId: null,
      pageIndex: 1,
      pageSize: 20
    }

    this.initData(this.firstSearch)
    // 查询获得项目列表
    projectquery().then(res => {
      this.options = res.data
    })
  },
  methods: {
    initData(info) {
      this.listLoading = true
      accountpage(info).then(res => {
        this.tabelData = res.data.records
        this.total = res.data.total
        setTimeout(() => {
          this.listLoading = false
        }, 100)
      })
    },
    // 分页
    getList() {
      this.firstSearch.pageIndex = this.listQuery.pageIndex
      this.firstSearch.pageSize = this.listQuery.pageSize
      this.initData(this.firstSearch)
    },
    add() {
      this.$router.push({ name: 'addaccount' })
    },
    search() {
      this.firstSearch.username = this.form.username
        ? this.form.username.trim()
        : null
      this.firstSearch.name = this.form.name
        ? this.form.name.trim()
        : null
      this.firstSearch.projectId = this.form.projectId
      this.listQuery.pageIndex = 1
      this.initData(this.firstSearch)
    },
    // 点击查看
    watch(id) {
      this.$router.push({ name: 'watchaccount', params: { id: id }})
    },
    // 点击编辑
    handleedit(id) {
      this.$router.push({ name: 'editaccount', params: { id: id }})
    }
  }
}
</script>

<style lang="scss" scoped>
.account-page {
	.add-btn {
		padding: 0 30px;
		margin-bottom: 20px;
	}
	.search-head {
		padding: 0 30px;
	}
	.tabel-box {
		padding: 20px 30px;
	}
	.search-group {
		margin-left: 100px;
	}
}
@media (max-width: 768px) {
	.account-page {
		.search-group {
			margin-left: 0px;
			display: block;
		}
	}
}
</style>
